'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/pagination';
import { StoriesSliderProps } from '@/types/managementSlider.types';
import styles from './storiesSlider.module.scss';
import { useState } from 'react';

const StoriesSlider = ({ slides, texts }: StoriesSliderProps) => {
  const [activeSlide, setActiveSlide] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleSlideChange = (newSlideId: number) => {
    if (newSlideId === activeSlide) return;
    setIsAnimating(true);
    setActiveSlide(newSlideId);
    setTimeout(() => setIsAnimating(false), 300); // Match this with CSS transition duration
  };

  return (
    <section className="container">
      <div className={styles.sliderWrapper}>
        <h2 className={styles.title}>
          Uncover the Stories Behind Our Professionals
        </h2>
        <style jsx global>{`
          .swiper-pagination {
            position: absolute;
            bottom: -40px !important;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .swiper-pagination-bullet {
            width: 19px;
            height: 4px;
            background: #d9d9d9;
            opacity: 1;
            margin: 0 6px;
            cursor: pointer;
            border-radius: 6px;
          }
          .swiper-pagination-bullet-active {
            background: #4d535f;
            width: 48px;
            height: 4px;
          }
        `}</style>
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 8,
            },
            390: {
              slidesPerView: 1.2,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 1.6,
              spaceBetween: 16,
            },
            650: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
            1200: {
              slidesPerView: 3.5,
              spaceBetween: 24,
            },
          }}
          className={styles.swiper}
        >
          {slides.map((slide) => (
            <SwiperSlide
              key={slide.id}
              onClick={() => handleSlideChange(slide.id)}
            >
              <div
                className={`${styles.slide} ${
                  activeSlide === slide.id ? styles.activeCardSlide : ''
                }`}
              >
                <Image
                  src={slide.image}
                  alt={slide.name}
                  width={48}
                  height={48}
                  className={styles.image}
                />
                <div className={styles.content}>
                  <h4 className={styles.name}>{slide.name}</h4>
                  <p className={styles.position}>{slide.position}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={styles.activeSlide}>
          {texts.find((text) => text.id === activeSlide) && (
            <div
              className={`${styles.text} ${isAnimating ? styles.textFading : ''}`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: texts.find((text) => text.id === activeSlide)!.text,
                }}
                className={styles.text}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StoriesSlider;
